import { connect } from 'react-redux';
import LandingPage from './LandingPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { push } from 'react-router-redux';
import { UserDetail } from '../../reducers/user';
import { handleCloseAlertLogin, handleCloseAlert } from 'src/actions/errorAction';
import { searchNameOrder, saveSearchType, getNotifications, startTimerNoti, stopTimerNoti, closeVideoPlayer, getRegularIntervalData } from 'src/actions/landingPageAction';
import { rowClick } from 'src/actions/liveOrderAction';
import { doCheckAuthentication, dologoutSession } from 'src/actions/aunthenticateAction';
import { stopTimerProductionStatus } from '../../actions/manufacturAction';
import { STORE_REDIRECT_FROM_DESIGNREADY } from 'src/reducers/completeorderfile';

export const mapStateToProps = (state: AppState) => {
    return {
        userDetails: state.user.userDetails,
        errorfilemsg: state.errorState.errorfilemsg,
        errorFileUploadedOpen: state.errorState.errorFileUploadedOpen,

        successFileUploadOpen: state.errorState.successFileUploadOpen,
        successfilemsg: state.errorState.successfilemsg,
        successsubmitmsg: state.errorState.successsubmitmsg,
        successSubmitOpen: state.errorState.successSubmitOpen,
        searchNameText: state.landingPage.searchName,
        searchResult: state.landingPage.searchValue,
        searchTrue: state.landingPage.searchTrue,
        searchTypeName: state.landingPage.searchType,

        notifications: state.landingPage.notifications,
        notificationsCount: state.landingPage.notificationCount,

        openVideoPlayer: state.landingPage.openVideoPlayer,
        videoSignedUrl: state.landingPage.videoSignedUrl,

        userProfileData: state.userProfileData.userProfiledata,
        loader: state.landingPage.loader
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onSubmit: () => {
            // dispatch(fetchCurrentUser);
        },
        addNewOrder: () => {
            // dispatch(fetchCurrentUser);
            dispatch(push('/app/neworder'));
        },
        feedback: () => {
            dispatch(push('/app/feedback'));
        },
        goHome: () => {
            dispatch(push('/app'));
        },
        profilePage: () => {
            dispatch(push('/app/profile'));
        },
        logout: () => {
            dispatch(push('/login'));
        },
        draftOrder: () => {
            dispatch(push('/app/draftOrders'));
        },
        newOrder: () => {
            dispatch(push('/app/newOrders'));
        },
        MUploadOrder: () => {
            dispatch(push('/app/uploadorder'));
        },
        liveOrder: () => {
            // dispatch(getLiveOrderData);
            dispatch(push('/app/liveOrders'));
        },
        completeOrder: () => {
            // dispatch(getCompleteOrderData);
            dispatch(push('/app/completeOrders'));            
            dispatch({ type: STORE_REDIRECT_FROM_DESIGNREADY, redirectDesignReady: false });
        },
        manucompletedOrder: () => {
            dispatch(push('/app/manuCompleteOrders'));            
            dispatch({ type: STORE_REDIRECT_FROM_DESIGNREADY, redirectDesignReady: false });
        },
        orderrawdata: () => {
            // dispatch(getCompleteOrderData);
            dispatch(push('/app/dailyorderreport'));
        },
        completeOrderDate: () => {
            dispatch(push('/app/archives'));
        },
        ordersOnHold: () => {
            dispatch(push('/app/ordersOnHold'));
        },
        ordersReturned: () => {
            dispatch(push('/app/inproduction'));
        },
        cancelOrder: () => {
            dispatch(push('/app/cancelorder'));
        },
        mOnHold: () => {
            dispatch(push('/app/casesOnHold'));
        },
        mUnderDesign: () => {
            dispatch(push('/app/underdesigning'));
        },
        mDesignReady: () => {
            dispatch(push('/app/designready'));
        },
        mnewcase: () => {
            dispatch(push('/app/newcases'));
        },
        mproduction: () => {
            dispatch(push('/app/caseInproduction'));
        },
        mcompleted: () => {
            dispatch(push('/app/caseCompleted'));
        },
        cfilterOrder: () => {
            dispatch(push('/app/orderSearch'));
        },
        mfilterOrder: () => {
            dispatch(push('/app/allcases'));
        },
        mfilterLessOrder: () => {
            dispatch(push('/app/productionstatus'));
        },
        handleClose: () => {
            dispatch(handleCloseAlertLogin);
        },
        handleCloseAlert: () => {
            dispatch(handleCloseAlert);
        },
        goUserAccount: () => {
            dispatch(push('/app/useraccount'));
        },
        goSupport: () => {
            dispatch(push('/app/supportticket'));
        },
        goFeedback: () => {
            dispatch(push('/app/feedbacklist'));
        },
        searchName: (searchName: string) => {
            dispatch(searchNameOrder(searchName));
        },
        onViewOrder: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        searchType: (searchType: string) => {
            dispatch(saveSearchType(searchType));
        },
        goNotification: () => {
            dispatch(getNotifications);
            dispatch(push('/app/notifications'));
        },
        goPayment: () => {
            dispatch(push('/app/paymentinvoices'));
        },
        goPaidInvoice: () => {
            dispatch(push('/app/paymentHistory'));
        },
        goMyinvoices: () => {
            dispatch(push('/app/myinvoices'));
        },
        goDesignPreference: () => {
            dispatch(push('/app/designpreference'));
        },
        goMaterialFiles: () => {
            dispatch(push('/app/materialfilesupload'));
        },
        // readNotifications: (messageId: string) => {
        //     dispatch(readNotifications(messageId));
        // },
        closeVideoPlayer: () => {
            dispatch(closeVideoPlayer);
        },
        onComponentDidMount: (userDetails: UserDetail) => {
            dispatch(startTimerNoti);
            dispatch(getRegularIntervalData);
        },
        oncomponentWillUnmount: () => {
            dispatch(stopTimerNoti);
            dispatch(stopTimerProductionStatus);
            dispatch(dologoutSession);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(saveSearchType('Order No'));
        }
    };
};

const LandingPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LandingPage);

export default LandingPageContainer;



// WEBPACK FOOTER //
// ./src/components/landingPage/LandingPageContainer.tsx